import axios, { AxiosResponse } from 'axios';

export const getMembers = (id: string): Promise<AxiosResponse> =>
	axios.get(`/snaps/members/${id}`);

export const inviteMember = (data: {
	usersIds: string[];
	snapId: string;
}): Promise<AxiosResponse> => axios.post(`/snaps/share/team-member`, data);
